import React from 'react';

import PreviewPane from './components/PreviewPane';

import { useIsGridFullScreenOrAnalytics } from './selectors/index.hooks';
import useDiscoveryLayout from './hooks/useDiscoveryLayout';
import { TStyling } from './components/_utils/types';

const RIGHT_PANE_OFFSET = 'calc(100% - 420px)';
const getPreviewPaneStyling = (
    isPreviewPaneVisible: boolean,
    isBottomPaneVisible: boolean,
    isGridFullscreen: boolean
): TStyling => {
    return [
        {
            predicate: () =>
                isPreviewPaneVisible &&
                isBottomPaneVisible &&
                !isGridFullscreen,
            style: {
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: RIGHT_PANE_OFFSET,
            },
        },
        {
            predicate: () =>
                isPreviewPaneVisible &&
                !isBottomPaneVisible &&
                !isGridFullscreen,
            style: {
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: RIGHT_PANE_OFFSET,
            },
        },
        {
            predicate: () =>
                isPreviewPaneVisible && isBottomPaneVisible && isGridFullscreen,
            style: {
                display: 'none',
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: RIGHT_PANE_OFFSET,
            },
        },
    ].find(({ predicate }) => predicate());
};

const RightPane = () => {
    const { isBottomPaneVisible, isPreviewPaneVisible } = useDiscoveryLayout();
    const isGridFullscreen = useIsGridFullScreenOrAnalytics();

    const previewPaneStyling = getPreviewPaneStyling(
        isPreviewPaneVisible,
        isBottomPaneVisible,
        isGridFullscreen
    );

    return (
        <>
            {previewPaneStyling && (
                <div style={previewPaneStyling.style}>
                    <PreviewPane />
                </div>
            )}
        </>
    );
};

export default RightPane;
